import {Injectable} from "@angular/core";
import { OutputSurgeArrestor, DefaultService} from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class OutputSurgeArrestorService {
    constructor(private powerSupplyService: DefaultService) {
        this.getAllOutputSurgeArrestors();
    }

    getAllOutputSurgeArrestors() {
        return this.powerSupplyService.getOutputSurgeArrestors()
            .pipe(map(result => result));
    }

    createOutputSurgeArrestor(model: OutputSurgeArrestor) {
        return this.powerSupplyService.createOutputSurgeArrestor(model)
            .pipe(map(result => result));
    }

    updateOutputSurgeArrestor(model: OutputSurgeArrestor) {
        return this.powerSupplyService.updateOutputSurgeArrestor(model)
            .pipe(map(result => result));
    }

    deleteOutputSurgeArrestor(id: number) {
        return this.powerSupplyService.deleteOutputSurgeArrestor(id)
            .pipe(map(result => result));
    }
}
